export default "__VITE_ASSET__88bab233__"